import InvoiceReportAPI from '@/clients/report/report'

const state = {}

const getters = {}

const actions = {
  async getInvoiceReport(context, params = { year: null, month: null, dateType: null }) {
    const token = context.getters.getAuthToken
    const data = await InvoiceReportAPI.get(token, params)
    return data
  },
}

const mutations = {}

export default {
  state,
  getters,
  actions,
  mutations,
}
